import {css} from '@emotion/css';
import {useMemo} from 'react';

import {transitionSpeed} from '../../../config/vars';
import {useWolfTheme} from '../../../contexts';

const useStyle = (open: boolean) => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            buttonText: css({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }),

            buttonChevron: {
                marginLeft: '1rem',
                transition: transitionSpeed,
                color: theme.palette.primary.default,
                ...(open && {transform: 'rotate(180deg)'}),
            },
        }),
        [open, theme.palette.primary.default]
    );
};

export default useStyle;
